import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { StateManagementService } from 'src/app/provide/state-management.service';
import { ApiEndPoint } from 'src/app/config/api-end-point';
declare var $;
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  standalone: false
})
export class HomepageComponent implements OnInit, OnDestroy {
  sliderConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  homepage!: UntypedFormGroup;
  itemPerPage = 4;
  currentPage = 1;
  totalItems: any;
  termsData: any;
  categoryListArrayNew: any;
  _id: any;
  a: any;
  totalPage: number = 0;
  emailN: any;
  emailRegex =
    /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/i;
  // latitude and longitude property
  latitude: any;
  longitude: any;
  ipAddress: string;
  serviceDetailDeals: any = new Array(1);
  // totalItems: any;
  // categoryListArray:[];
  // categoryListArray: never[];
  isLoaded: any = new Array(4);
  // 14-4-2025 
  recommendedData: any[] = [];
  totalRecommendationItems: number = 10;
  searchQuery: string = '';



  constructor(
    private activatedroute: ActivatedRoute,
    public commonService: CommonService,
    private router: Router,
    public stateManagement: StateManagementService,
    private cdr: ChangeDetectorRef
  ) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this._id = res._id;
    });
    localStorage.setItem('recomendation', "0")

    if (localStorage.getItem('token')) {
      if (localStorage.getItem('userType') == 'RETAILER') {
        this.router.navigate(['/retailer-home']);
      }
    }
  }
  isLogin: any;

  ngOnInit(): void {
    this.commonService.profileUpdateItem.next(true);
    // this.getBannerProductList()
    window.scrollTo(0, 0);
    this.getGlobalData();
    // this.homePage();
    // this.getCategoryList();
    this.homepage = new UntypedFormGroup({
      email: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(
          /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/i
        ),
      ]),
    });
    this.isLogin = localStorage.getItem('token');

    // this.stateManagement.categoryCustomer.subscribe((res) => {
    //   if (res) {
    //     this.categoryListArray = res
    //   }
    //   else {
    //     this.getCategoryLists()

    //   }
    // })
    this.stateManagement.getProductCustomer.subscribe((res) => {
      if (res) {
        this.bannerData = res;
      } else {
        this.getLocation();
      }
    });
    this.stateManagement.getDealCustomer.subscribe((res) => {
      if (res) {
        this.serviceDetail = res;

        for (let index = 0; index < this.serviceDetail.length; index++) {
          this.getCoundown(this.serviceDetail[index]['dealEndTime'], index);
        }
      }
    });
    this.stateManagement.getserviceOnBooking.subscribe((res) => {
      if (res) {
        this.serviceDetailDeals = res;

        for (let index = 0; index < this.serviceDetailDeals.length; index++) {
          this.getCoundownNew(
            this.serviceDetailDeals[index]['dealEndTime'],
            index
          );
        }
      }
    });
    // this.stateManagement.getServiceCustomer.subscribe((res) => {
    //   if (res) {
    //     this.serviceData = res

    //   }
    //   else {
    //     this.getServiceProduct()

    //   }
    // })
    // this.getcontent();
    // this.getCategoryLists()
    this.getLocation();
    // this.getBanner()
    // this.getServiceProduct()
    navigator.geolocation.getCurrentPosition(
      function (position) {
        // alert('allow');
      },
      function () {
        // alert(
        //   'You need to enable geolocation services in your browser to use this feature.'
        // );
      }
    );
    this.getPosition().then((pos) => {
      localStorage.setItem('location', JSON.stringify(pos));
    });

    // this.getRecommendation();
    // this.getLocation();
  }



  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({
            lng: +resp.coords.longitude.toFixed(6),
            lat: +resp.coords.latitude.toFixed(6)
          });

        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (position) {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;

            console.log(this.latitude, 'latitude   .........');
            console.log(this.longitude, 'longitude ........   ');
            // this.getBanner()
            // this.getproduct()
            this.getGlobalData();
            // this.getBannerBooking()
          }
        },
        (error) => console.log(error)
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }

  preventSpace(event: any) {
    if ((event.charCode == 32 || event.charCode == 64) && !event.target.value) {
      event.preventDefault();
    }
  }
  isEmailValid(): boolean {
    let a = String(this.emailN).match(this.emailRegex);
    return a ? false : true;
  }

  loggedin() {
    return localStorage.getItem('token');
  }

  onLogout() {
    localStorage.removeItem('token');
  }
  // ========================

  getcontent() {
    this.commonService.getApi('user/homePageForWholeSaler', 1).subscribe(
      (res: any) => {
        this.commonService.showSpinner();

        if (res['responseCode'] == 200) {
          this.termsData = res['result']['dealDetails']['docs'];
          this.totalItems = res.result.total;

          this.commonService.hideSpinner();
          // this.commonService.successToast(res.responseMessage);
        } else {
          this.termsData = [];
          this.totalItems = 0;
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
        }
      },
      (err) => {
        if (err.responseCode == 404) {
          this.termsData = [];
          this.totalItems = 0;
          // this.commonService.warningToast(err['error']['responseMessage'])
        }
      }
    );
  }

  pagination(event: number) {
    this.currentPage = event;
    this.getcontent();
  }

  // ============categay list===========
  categoryListArray: any = [];
  // cache for exact product totals per category id
  categoryCounts: { [categoryId: string]: number } = {};

  // getCategoryLists() {

  //   let apiReqUrl: any = `admin/listCategory`
  //   // this.commonService.showSpinner();
  //   let apiReqData: any = {
  //     // page: String(this.currentPage),
  //     // limit: String(this.itemPerPage)
  //   }
  //   // remove empty keys from request body
  //   // apiReqData = this.commonService['removeEmptyKey'](apiReqData)
  //   apiReqData = this.commonService.removeEmptyKey(apiReqData)
  //   let a = this.commonService.isLoggedIn() ? 1 : 0
  //   this.commonService.postApi(apiReqUrl, apiReqData, a).subscribe((res: any) => {
  //     if (res.responseCode == 200) {
  //       this.categoryListArray = res.result.docs ? res.result.docs : '';
  //       this.totalItems = res.result.total
  //       this.commonService.hideSpinner();
  //       // this.commonService.successToast(res.responseMessage);
  //     } else {
  //       this.categoryListArray = []
  //       this.totalItems = 0
  //       this.commonService.hideSpinner();
  //       this.commonService.errorToast(res.responseMessage)
  //     }
  //   })
  // }

  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }

  forID(_id: any) {
    this.router.navigate(['/deal-details'], { queryParams: { _id: _id } });
  }

  // knoemore
  descrition: any;

  // ====================================================save button================================
  getDeals() {
    if (!String(this.emailN).match(this.emailRegex)) {
      this.commonService.errorToast('Please enter valid email');
      return;
    }
    let data = {
      email: this.emailN,
    };

    let apiReqUrl: any = `user/addSubscription`;
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, data, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.commonService.hideSpinner();
        this.commonService.showSuccessToast(res.responseMessage);
        this.emailN = '';
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }
  viewParticularProducts(productId: any) {
    this.router.navigate(['/list-product'], {
      queryParams: { _id: productId },
    });
  }
  onSearch(id?: any) {
    // this.showSearchType = false;
    if (this.searchQuery && this.searchQuery.trim()) {
      localStorage.setItem('searchQuery', this.searchQuery.trim());
    }
    if (id) {
      localStorage.setItem('category', id);
    }
    this.router.navigate(['/search-product']);
    this.commonService.onFirstComponentButtonClick();
    // this.router.navigate(['/search-product'], { queryParams: { _id: id,search:search} })
  }
  bannerData: any = new Array(1);
  serviceDetail: any = new Array(1);
  // getBanner() {

  //   let url = `deal/listDealByLocation`
  //   // let url =`product/listProductBySortion`
  //   let data = {
  //     "dealType": "PRODUCT",
  //     "userType": this.getEndUrlSegment() == 'retailer-home' ? 'WHOLE_SALER' : "RETAILER",
  //     'lng': this.longitude,
  //     'lat': this.latitude,
  //     'page': this.currentPage,
  //     'limit': 10
  //   }

  //   this.commonService.removeEmptyKey(data)
  //   // this.commonService.showSpinner()
  //   let a = this.commonService.isLoggedIn() ? 1 : 0
  //   this.commonService.postApi(url, data, a).subscribe((res: any) => {
  //     if (res.responseCode == 200) {

  //       if (this.timerInterval) {
  //         clearInterval(this.timerInterval);
  //         this.countDown = [];
  //       }
  //       this.serviceDetail = res.result.docs
  //       this.totalItems = res.result.totalPages
  //       for (let index = 0; index < this.serviceDetail.length; index++) {
  //         this.getCoundown(this.serviceDetail[index]['dealEndTime'], index);
  //       }
  //       // this.dealData = res["result"]["docs"];
  //       this.commonService.hideSpinner()

  //       this.commonService.hideSpinner()
  //     }
  //     else{
  //       this.serviceDetail = []
  //     }
  //   },(err)=>{
  //     this.serviceDetail = []
  //   })
  // }
  // getBannerBooking() {

  //   let url = `deal/dealsListOnCategory`
  //   // let url =`product/listProductBySortion`
  //   // let data = {
  //   //   "dealType": "PRODUCT",
  //   //   "userType": "RETAILER",
  //   //   'lng': this.longitude,
  //   //   'lat': this.latitude,
  //   //   'page': this.currentPage,
  //   //   'limit': 10
  //   // }

  //   // this.commonService.removeEmptyKey(data)
  //   // this.commonService.showSpinner()
  //   let token = localStorage.getItem('token') ? 1 : 0
  //   this.commonService.getApi(url,token).subscribe((res: any) => {
  //     if (res.responseCode == 200) {

  //       if (this.timerInterval) {
  //         clearInterval(this.timerInterval);
  //         this.countDown = [];
  //       }
  //       this.serviceDetailDeals = res.result
  //       this.totalItems = res.result.totalPages
  //       for (let index = 0; index < this.serviceDetailDeals.length; index++) {
  //         this.getCoundownNew(this.serviceDetailDeals[index]['dealEndTime'], index);
  //       }
  //       // this.dealData = res["result"]["docs"];
  //       this.commonService.hideSpinner()

  //       this.commonService.hideSpinner()
  //     }
  //     else {
  //       this.serviceDetailDeals = []
  //     }
  //   }, (err: any) => {
  //     this.serviceDetailDeals = []
  //   })
  // }

  myTimer() { }
  // getDealDescription
  countDown: string[] = [];
  timerInterval: any = [];
  countDownNew: any = [];
  timerIntervalNew: any = [];
  new: any;
  getCoundown(date: Date, i: number) {
    var countDownDate = new Date(date).getTime();
    let me = this;
    // Update the count down every 1 second

    this.timerInterval[i] = setInterval(() => {
      if (true) {
        // Get today's date and time
        let now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="demo"
        this.countDown[i] =
          days + 'D:' + hours + 'H:' + minutes + 'M:' + seconds + 'S';
        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(me.timerInterval);
          me.countDown[i] = 'EXPIRED';
        }
      }

      // me.countDown[i] = mm
    }, 1000);
  }
  getCountDownOld(i, date?: Date) {
    if (!this.countDown[i]) {
      this.getCoundown(date, i);
    }
    return this.countDown[i];
  }
  getCoundownNew(date: Date, i: number) {
    var countDownDate = new Date(date).getTime();
    let me = this;
    // Update the count down every 1 second

    this.timerIntervalNew[i] = setInterval(() => {
      if (true) {
        // Get today's date and time
        let now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="demo"
        me.countDownNew[i] =
          days + 'D:' + hours + 'H:' + minutes + 'M:' + seconds + 'S'; // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(me.timerIntervalNew);
          me.countDownNew[i] = 'EXPIRED';
        }
      }

      // me.countDown[i] = mm
    }, 1000);
  }
  getCountDown(i) {
    if (!this.countDownNew[i] && this.serviceDetailDeals && this.serviceDetailDeals[i]) {
      // Initialize countdown if it doesn't exist yet
      this.getCoundownNew(this.serviceDetailDeals[i].dealEndTime, i);
    }
    return this.countDownNew[i];
  }
  // getproduct() {
  //   let url = `product/listProductBySortion`
  //   let data = {
  //     // "dealType" :  "PRODUCT",
  //     "userType": this.getEndUrlSegment() == 'retailer-home' ? 'WHOLE_SALER' : "RETAILER",
  //     'lng': this.longitude,
  //     'lat': this.latitude,
  //     'page': this.currentPage,
  //     'limit': 10
  //   }
  //   let a = this.commonService.isLoggedIn() ? 1 : 0

  //   // this.commonService.showSpinner()
  //   this.commonService.postApi(url, data, a).subscribe((res: any) => {
  //     if (res.responseCode == 200) {
  //       this.bannerData = res["result"]["docs"];
  //       this.commonService.hideSpinner()

  //       this.commonService.hideSpinner()
  //     }
  //   })
  // }
  serviceData: any = new Array(1);
  // getServiceProduct() {
  //   let url = `service/listCategoryService`
  //   let data = {
  //     // "dealType" :  "PRODUCT",
  //     'page': this.currentPage,
  //     'limit': 10
  //   }

  //   let a = this.commonService.isLoggedIn() ? 1 : 0
  //   this.commonService.postApi(url, data, a).subscribe((res: any) => {
  //     if (res.responseCode == 200) {
  //       this.serviceData = res["result"]["docs"];

  //     }
  //   })
  // }
  // directPage(url) {
  //   if (url) {
  //     window.open(url, '_blank');
  //   }
  // }
  BannerListArray: any = [];

  // getBannerProductList() {
  //   let apiReqUrl: any = `user/listBanner`
  //   let apiReqData: any = {
  //     // page: String(this.currentPage),
  //     limit: String(this.itemPerPage),
  //   }
  //   apiReqData = this.commonService.removeEmptyKey(apiReqData)
  //   this.commonService.postApi(apiReqUrl, apiReqData, 0).subscribe((res: any) => {
  //     if (res.responseCode == 200) {
  //       this.BannerListArray = res.result.docs ? res.result.docs : '';
  //       this.totalItems = res.result.total
  //       this.commonService.hideSpinner();
  //     } else {
  //       this.BannerListArray = []
  //       this.totalItems = 0
  //       this.commonService.hideSpinner();
  //       this.commonService.errorToast(res.responseMessage)
  //     }
  //   }, (err: any) => {
  //     if (err.responseCode == 404) {
  //       this.BannerListArray = []
  //       this.totalItems = 0

  //     }
  //   })
  // }
  navigateToViewProduct(_id, q) {
    this.router.navigate(['/product-view-customer'], {
      queryParams: { _id: _id, q },
    });
  }
  navigateToViewService(_id, catName, desc) {
    this.router.navigate(['/customer-service-available'], {
      queryParams: { _id: _id, catName: catName, desc: desc },
    });
  }
  navigateToViewProducts(_id, categoryName) {
    this.router.navigate(['/customer-category-list-view'], {
      queryParams: { _id: _id, categoryName: categoryName },
    });
  }

  dealVIEw(_id, q) {
    this.router.navigate(['/customer-product-view'], {
      queryParams: { _id: _id, q },
    });
  }
  dealVIEwNew(_id, q) {
    sessionStorage.setItem('selectedService', JSON.stringify(_id));
    this.router.navigate(['/customer-service-deal-view-particular']);
  }

  onImageLaod(e) {
    if (e) {
      e.isLoaded = true;
      // Use setTimeout to ensure change detection runs in next tick
      setTimeout(() => {
        this.cdr.detectChanges();
      }, 0);
    }
    return true;
  }
  onBannerLaod(i) {
    this.isLoaded[i] = true;
  }
  onImageError(e) {
    console.log('Image failed to load:', e);
    // You can add fallback image logic here if needed
    return false;
  }
  getPercentage(dealPrice, actualPrice) {
    let minus = actualPrice - dealPrice;
    let getDiscountP = minus / actualPrice;
    let getPercent = getDiscountP * 100;
    return getPercent.toFixed(2);
  }
  length(n) {
    return new Array(n);
  }
  ngOnDestroy(): void {
    // this.stateManagement.categoryCustomer.next(this.categoryListArray)
    // this.stateManagement.getProductCustomer.next(this.bannerData)
    // this.stateManagement.getDealCustomer.next(this.serviceDetail)
    // this.stateManagement.getServiceCustomer.next(this.serviceData)
    // this.stateManagement.getserviceOnBooking.next(this.serviceDetailDeals)
  }
  getEndUrlSegment(): string {
    const url = this.router.url;
    const segments = url.split('/');
    const lastSegmentWithQueryParamsAndFragments =
      segments[segments.length - 1];
    const endUrlSegment = lastSegmentWithQueryParamsAndFragments
      .split('?')[0]
      .split('#')[0];
    return endUrlSegment;
  }
  getDealPrice(price, percentage): string {
    let dealPrice = Number(price) - Number(price) * Number(percentage / 100);
    return dealPrice.toFixed(2);
  }
  globalData: any;
  loading = true
  getGlobalData() {
    console.log(this.latitude, 'latitudeeeeeeee');
    let data = {
      dealType: 'PRODUCT',
      userType:
        this.getEndUrlSegment() == 'retailer-home' ? 'WHOLE_SALER' : 'RETAILER',
      lng: this.longitude,
      lat: this.latitude,
      page: this.currentPage,
      limit: 12,
      categoriesLimit: 12,
      productsLimit: 12,
    };
    // Try multiple parameter variations to ensure API respects the limit
    let url = `user/homePageApi?dealType=${data.dealType}&userType=${data.userType}&lng=${data.lng}&lat=${data.lat}&limit=${data.limit}&categoriesLimit=${data.categoriesLimit}&productsLimit=${data.productsLimit}`;

    let a = this.commonService.isLoggedIn() ? 1 : 0;
    this.loading = true
    // this.commonService.showSpinner()
    this.commonService.getApi(url, a).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.globalData = res['result'];
        this.BannerListArray = res.result.banner ? res.result.banner : '';
        // Limit categories and products to exactly 12 items each
        const categories = res?.result?.categories || [];
        const products = res?.result?.products || [];

        // Log what API returns before slicing
        console.log('API returned categories:', categories?.length || 0);
        console.log('API returned products:', products?.length || 0);

        // Ensure we get exactly 12 items (or as many as available if less than 12)
        this.categoryListArray = Array.isArray(categories)
          ? categories.slice(0, 12).map(item => ({ ...item, isLoaded: false }))
          : [];
        this.bannerData = Array.isArray(products)
          ? products.slice(0, 12).map((item, index) => ({
            ...item,
            isLoaded: true // Show all images immediately since they're eager-loaded
          }))
          : [];

        // Log final counts after slicing
        console.log('Final categories count:', this.categoryListArray.length);
        console.log('Final products count:', this.bannerData.length);

        // If API returned less than 12, log a warning
        if (categories?.length < 12) {
          console.warn(`API only returned ${categories.length} categories. Requested 12.`);
        }
        if (products?.length < 12) {
          console.warn(`API only returned ${products.length} products. Requested 12.`);
        }

        this.recommendedData = res?.result?.productRecomended?.map(item => ({ ...item, isLoaded: false })) || [];
        this.serviceDetail = res?.result?.deals_on_product?.map(item => ({ ...item, isLoaded: false })) || [];
        this.serviceData = res?.result?.booking_categories?.map(item => ({ ...item, isLoaded: false })) || [];
        this.serviceDetailDeals = res?.result?.dealsOnBooking?.map(item => ({ ...item, isLoaded: false })) || [];
        for (let index = 0; index < this.serviceDetailDeals.length; index++) {
          this.getCoundownNew(
            this.serviceDetailDeals[index]['dealEndTime'],
            index
          );
        }
        // fetch accurate product counts per category once categories are loaded
        if (Array.isArray(this.categoryListArray) && this.categoryListArray.length) {
          this.fetchCategoryCounts();
        }

        // If API returned less than 12 categories, fetch more via separate API call
        if (this.categoryListArray.length < 12) {
          this.fetchCategoriesWithLimit(12);
        }

        // If API returned less than 12 products, fetch more via separate API call
        if (this.bannerData.length < 12) {
          this.fetchProductsWithLimit(12);
        }

        // this.commonService.hideSpinner()

        // this.commonService.hideSpinner()
      }
      this.loading = false
      this.cdr.detectChanges();
      setTimeout(() => {
        // Fallback for jquery if mixed usage
        if (typeof $ !== 'undefined') {
          const $carousel = $('#carouselExampleControls');
          if ($carousel.length) {
            // Ensure first item is active so it's visible
            if ($carousel.find('.carousel-item.active').length === 0) {
              $carousel.find('.carousel-item').first().addClass('active');
            }
            // Initialize with options and start cycling
            $carousel.carousel({
              interval: 5000,
              ride: 'carousel',
              pause: false
            });
            $carousel.carousel('cycle');
          }
        }
      }, 500);
    }, (error) => {
      this.loading = false
    });
  }

  // Fetch categories separately with limit of 12
  fetchCategoriesWithLimit(limit: number) {
    let apiReqUrl: any = `admin/listCategory`;
    let apiReqData: any = {
      page: '1',
      limit: String(limit)
    };
    apiReqData = this.commonService.removeEmptyKey(apiReqData);
    let a = this.commonService.isLoggedIn() ? 1 : 0;

    this.commonService.postApi(apiReqUrl, apiReqData, a).subscribe((res: any) => {
      if (res.responseCode == 200) {
        const fetchedCategories = res.result.docs ? res.result.docs : [];
        // Replace with fetched categories, limited to 12
        this.categoryListArray = fetchedCategories.slice(0, limit).map(item => ({ ...item, isLoaded: false }));

        console.log('Fetched categories with limit. Total now:', this.categoryListArray.length);

        // Update category counts for categories
        if (this.categoryListArray.length) {
          this.fetchCategoryCounts();
        }
      }
    }, (error) => {
      console.error('Error fetching categories:', error);
    });
  }

  // Fetch products separately with limit of 12
  fetchProductsWithLimit(limit: number) {
    let url = `product/listProductBySortion`;
    let data = {
      userType: this.getEndUrlSegment() == 'retailer-home' ? 'WHOLE_SALER' : 'RETAILER',
      lng: this.longitude,
      lat: this.latitude,
      page: '1',
      limit: String(limit)
    };
    this.commonService.removeEmptyKey(data);
    let a = this.commonService.isLoggedIn() ? 1 : 0;

    this.commonService.postApi(url, data, a).subscribe((res: any) => {
      if (res.responseCode == 200) {
        const fetchedProducts = res.result.docs ? res.result.docs : [];
        // Replace with fetched products, limited to 12
        this.bannerData = fetchedProducts.slice(0, limit).map((item, index) => ({
          ...item,
          isLoaded: true // Show all images immediately since they're eager-loaded
        }));

        console.log('Fetched products with limit. Total now:', this.bannerData.length);
      }
    }, (error) => {
      console.error('Error fetching products:', error);
    });
  }

  // Fetch accurate totals per category using existing listing API (reads count only)
  private fetchCategoryCounts(): void {
    const tokenFlag = this.commonService.isLoggedIn() ? 1 : 0;
    const userType = this.getEndUrlSegment() == 'retailer-home' ? 'WHOLE_SALER' : 'RETAILER';
    const requests = (this.categoryListArray || [])
      .filter((cat: any) => cat && cat._id)
      .map((cat: any) => {
        const apiReqUrl = `product/listProductBySortion`;
        const apiReqData: any = {
          page: '1',
          limit: '1', // limit minimal; we only need total count
          categoryId: cat._id,
          userType,
          lng: this.longitude,
          lat: this.latitude,
        };
        this.commonService.removeEmptyKey(apiReqData);
        return this.commonService.postApi(apiReqUrl, apiReqData, tokenFlag).subscribe(
          (res: any) => {
            if (res && res.responseCode === 200 && res.result && typeof res.result.count === 'number') {
              this.categoryCounts[cat._id] = res.result.count;
            } else {
              this.categoryCounts[cat._id] = 0;
            }
          },
          () => {
            this.categoryCounts[cat._id] = 0;
          }
        );
      });
  }

  // Recommendation method
  // getRecommendation() {
  //   this.commonService.showSpinner();
  //   this.commonService.getApi('product/getUserRecommendations', 1).subscribe(
  //     (res: any) => {
  //       console.log('response of recommendations', res);

  //       if (res?.responseCode === 200 && res?.result?.length > 0) {
  //         this.recommendedData = res.result.map((item: any) => ({
  //           ...item,
  //           isLoaded: false,
  //         }));
  //         this.totalRecommendationItems = res.result.length;
  //       } else {
  //         this.recommendedData = [];
  //         this.totalRecommendationItems = 0;
  //         this.commonService.errorToast(res.responseMessage);
  //       }

  //       this.commonService.hideSpinner();
  //     },
  //     (err) => {
  //       this.commonService.hideSpinner();
  //       this.recommendedData = [];
  //       this.totalRecommendationItems = 0;
  //       if (err?.responseCode !== 404) {
  //         this.commonService.errorToast('Something went wrong');
  //       }
  //     }
  //   );
  // }

  banerredirect(url) {
    if (url) {
      window.open(url)
    }
  }

  setRecomend() {
    this.router.navigate(["/customer-product-list"], { queryParams: { recomendation: true } })
    localStorage.setItem('recomendation', "1")
  }

  toggleFeaturedWishlist(event: Event, product: any) {
    event.stopPropagation();

    if (!product || !product._id) {
      return;
    }

    if (!this.commonService.isLoggedIn()) {
      this.commonService.errorToast('Please login to add items to wishlist');
      return;
    }

    if (product.isLike) {
      this.removeProductFromWishlist(product);
    } else {
      this.addProductToWishlist(product);
    }
  }

  private addProductToWishlist(product: any) {
    const apiReqUrl = `${ApiEndPoint.addWishListProduct}?productId=${product._id}`;
    this.commonService.showSpinner();

    this.commonService.postApi(apiReqUrl, {}, 1).subscribe(
      (res: any) => {
        this.commonService.hideSpinner();
        if (res.responseCode === 200) {
          product.isLike = true;
          this.commonService.successToast('Product added to wishlist');
        } else {
          this.commonService.errorToast(res.responseMessage || 'Failed to add to wishlist');
        }
      },
      () => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Something went wrong');
      }
    );
  }

  private removeProductFromWishlist(product: any) {
    const apiReqUrl = `${ApiEndPoint.addWishListProduct}?productId=${product._id}`;
    this.commonService.showSpinner();

    this.commonService.postApi(apiReqUrl, {}, 1).subscribe(
      (res: any) => {
        this.commonService.hideSpinner();
        if (res.responseCode === 200) {
          product.isLike = false;
          this.commonService.successToast('Product removed from wishlist');
        } else {
          this.commonService.errorToast(res.responseMessage || 'Failed to remove from wishlist');
        }
      },
      () => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Something went wrong');
      }
    );
  }

  // Helper methods for new UI
  // getRandomProductCount(): number {
  //   const counts = [150, 200, 300, 120, 180, 250];
  //   return counts[Math.floor(Math.random() * counts.length)];
  // }

  // getBrandName(productName: string): string {
  //   const brands = ['TECHBRAND', 'FASHIONDO', 'HOMESTYLE', 'FITNESSCORP', 'BOOKWORMS', 'PREMIUM'];
  //   return brands[Math.floor(Math.random() * brands.length)];
  // }

  reloadHomepage() {
    // Reload the page to refresh the homepage, same as clicking on banner
    window.location.reload();
  }

}
